import getIn from 'lodash/get';
import isFunction from 'lodash/isFunction';

/**
 * @param  {Function} handler - a DOM event handler function to wrap
 * @returns {Function} - the handler function in a wrapper function
 *                      that stops DOM event propagation before it calls the original handler
 */
export function handlerNoPropagate(handler: $TSFixMeFunction) {
  return (e: Event): void => {
    e.stopPropagation();
    handler(e);
  };
}

export function parseTrackingEvents(events: Event[]): Record<string, Event> | null {
  const eventMapping: Record<string, Event> = {};
  let error = false;
  events.forEach((event: $TSFixMe) => {
    if (!event.type || !event.urls) {
      error = true;
      return;
    }
    eventMapping[event.type] = event.urls;
  });
  if (error) {
    return null;
  }
  return eventMapping;
}

export function preventDefaultAndCall(fn: $TSFixMeFunction) {
  return (e: $TSFixMe): void => {
    e.preventDefault();
    fn(e);
  };
}

export function attemptComponentEventNotification(
  handler: $TSFixMeFunction,
  notifier: $TSFixMeFunction,
  eventData: $TSFixMe,
): $TSFixMeFunction {
  if (isFunction(handler) && isFunction(notifier)) {
    return (e: $TSFixMe) => {
      const destinationUrl = getIn(e, 'currentTarget.pathname');
      const data = isFunction(eventData) ? eventData() : eventData;
      if (destinationUrl) {
        notifier({ ...{ destinationUrl }, ...data });
      } else {
        notifier(data);
      }
      handler(e);
    };
  }
  return handler;
}
